export default __webpack_public_path__ + "static/media/hashtag.79d89cc4.svg";